import React from 'react';
import { TouchableOpacity } from 'react-native';
import { useThemedStyles } from '../../hooks/useThemedStyles';

export const ListItem = ({
	children,
	onPress,
	condensed,
	style: styleFromProps = {},
}) => {
	const styles = useThemedStyles(createStyles);

	const style = condensed ? styles.condensed : styles.normal;

	return (
		<TouchableOpacity
			activeOpacity={onPress ? 0.5 : 1}
			style={[style, styleFromProps]}
			onPress={onPress}
		>
			{children}
		</TouchableOpacity>
	);
};

const createStyles = ({ ui: { colors, radius } }) => ({
	condensed: {
		borderBottomWidth: 1,
		borderBottomColor: colors.border,
		borderRadius: 0,
		padding: 16,
		marginBottom: 0,
		backgroundColor: colors.canvas,
	},
	normal: {
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.raisedBorder,
		padding: 16,
		marginTop: 8,
		marginBottom: 8,
		// marginHorizontal (not Left/Right) so items can set their own marginHorizontal.
		marginHorizontal: 8,
		backgroundColor: colors.raised,
	},
});

